/**
 * Key/value storage for PowerSync auth tokens using localStorage.
 */

import type { TokenStorage } from "@apunte-digital/shared";

export const tokenStorage: TokenStorage = {
  // oxlint-disable-next-line typescript-eslint/require-await
  getItem: async (key) => localStorage.getItem(key),
  // oxlint-disable-next-line typescript-eslint/require-await
  setItem: async (key, value) => {
    localStorage.setItem(key, value);
  },
};
